import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

const REMARK_PLUGINS = [remarkGfm, remarkBreaks];

// Rest props are forwarded to the wrapper so callers can add a `data-testid` or aria
// attributes without this component having to know about them. The rendered text still
// comes only from `children`; a non-string child is ignored.
function Markdown({ children, className = '', ...rest }) {
  const source = typeof children === 'string' ? children : '';

  if (!source.trim()) return null;

  return (
    <div className={`markdown ${className}`.trim()} {...rest}>
      <ReactMarkdown
        remarkPlugins={REMARK_PLUGINS}
        components={{
          a({ node, children, ...props }) {
            return (
              <a {...props} target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            );
          },
        }}
      >
        {source}
      </ReactMarkdown>
    </div>
  );
}

export default Markdown;
